<template>
  <div class="read-aloud-detail">
    <organization-breadcrumb
      :items="[$t('study_sets.curriculum'), $t('read_aloud.title')]"
    />
    <div id="read-aloud-page">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :md="14">
          <router-link
            :to="'/organization/' + organizationId + '/read-aloud'"
            style="font-size: 16px; font-weight: 600; line-height: 24px"
          >
            <i class="el-icon-back"></i> {{ $t("study_sets.back") }}
          </router-link>

          <div class="sub-header flex items-center justify-between">
            <rename-form
              v-if="editMode"
              :oldName="detailReadAloudData.name"
              v-on:cancel-rename="cancelRename"
              v-on:handle-edit-name="handleEditName"
            >
            </rename-form>
            <p v-else class="study-set-name">
              {{ detailReadAloudData.name }}
              <span
                class="edit-name"
                @click="() => (editMode = true)"
                :title="$t('assignments.details.edit_timeline')"
              >
                <i class="elsa-icon-edit2" />
              </span>
            </p>
            <div class="flex">
              <span
                id="assign-to-group-btn"
                class="assign-to-class"
                @click="handleAssignToClassStudySet()"
              >
                <chip>
                  {{
                    $t(
                      $i18nLabelsHelper(
                        currentOrganizationType,
                        `study_sets.assign_to_group`
                      )
                    )
                  }}
                </chip>
              </span>
              <el-popover
                class="study-set-popover"
                placement="bottom-end"
                trigger="click"
                :width="130"
                :visible-arrow="false"
              >
                <div class="actions-list">
                  <!-- <span @click="handleDuplicateReadAloud(getCurrentStudySet.id)">
                    <span class="actions-list-item">
                      <font-awesome-icon icon="copy" />
                    </span>
                    {{ $t("study_sets.table.duplicate") }}
                  </span> -->
                  <span
                    @click="handleEditReadAloud(detailReadAloudData.id)"
                    :class="{
                      'btn-edit-disabled': canAccessReadAloud(detailReadAloudData.id, 'view')
                    }"
                  >
                    <span class="actions-list-item">
                      <font-awesome-icon icon="pen" />
                    </span>
                    {{ $t("study_sets.table.edit") }}
                  </span>
                  <span
                    v-show="false"
                    class="remove-read-aloud"
                    @click="handleDeleteReadAloud()"
                  >
                    <span class="actions-list-item">
                      <font-awesome-icon
                        :icon="['fas', 'trash-alt']"
                        style="
                          color: #eb5757;
                          font-size: 14px;
                          line-height: 14px;
                        "
                      />
                    </span>
                    {{ $t("study_sets.table.remove") }}
                  </span>
                </div>
                <el-tooltip
                  :visible-arrow="false"
                  class="item"
                  content="Options"
                  placement="top"
                  slot="reference"
                >
                  <el-button>
                    <i class="el-icon-more"></i>
                  </el-button>
                </el-tooltip>
              </el-popover>
            </div>
          </div>
          <div>
            <div class="read-aloud-main">
              <read-aloud-detail
                :readAloudDetails="detailReadAloudData"
                :organizationType="currentOrganizationType"
                :organizationId="currentOrganizationId"
              />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <confirm-delete-read-aloud-modal
      :dialogVisible="modals.showConfirmDelete"
      append-to-body
      v-on:closed="modals.showConfirmDelete = false"
      v-on:delete="handleConfirmDeleteReadAloud"
    >
      <template v-slot:body>
        <h4 id="leave-modal-title">
          {{ $t("read_aloud.modals_delete_title") }}
        </h4>
      </template>
    </confirm-delete-read-aloud-modal>
    <add-assignment-wrapper ref="addAssignment" v-on:reload="handleReload" />
  </div>
</template>

<script>
import ReadAloudDetail from "@/components/read-aloud/details/ReadAloudDetail";
import { mapActions, mapGetters } from "vuex";
import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
import Chip from "@/components/common/Chip";
import { successMessage, warningMessage } from "@/utils/messages";
import ConfirmDeleteReadAloudModal from "@/components/modals/bases/ConfirmDelete.vue";
import AddAssignmentWrapper from "@/components/modals/read-aloud/AddAssignmentWrapper";
import RenameForm from "@/components/common/RenameForm";

export default {
  props: {
    readAloudId: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    ReadAloudDetail,
    OrganizationBreadcrumb,
    Chip,
    ConfirmDeleteReadAloudModal,
    AddAssignmentWrapper,
    RenameForm,
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
      currentOrganizationId: "organization/currentOrganizationId",
      getDetailReadAloud: "readAlouds/getDetailReadAloud",
    }),
    isStudySetEditable() {
      if (
        this.buildingStudySet.assigned_group &&
        this.buildingStudySet.assigned_group.length > 0
      ) {
        return false;
      }
      return true;
    },
    organizationId() {
      return this.$store.state.organization.currentOrganizationId;
    },
  },
  data() {
    return {
      modals: {
        showConfirmDelete: false,
      },
      editMode: false,
      checkedReadAlouds: {
        view: [],
        edit: [],
      },
      detailReadAloudData: {},
    };
  },
  methods: {
    ...mapActions({
      deleteReadAloudAction: "readAlouds/deleteReadAloud",
      updateReadAloudName: "readAlouds/updateReadAloudName",
      checkReadAloudPermission: "readAlouds/checkReadAloudPermission",
    }),
    handleAssignToClassStudySet() {
      this.$refs.addAssignment.handleAssignToClassReadAloud(
        this.getDetailReadAloud
      );
    },
    handleDeleteReadAloud() {
      this.modals.showConfirmDelete = true;
    },
    // async handleDuplicateReadAloud(studySetId) {
    //   // TODO duplicate study set
    //   return this.$router.push({
    //     name: "read-aloud-duplicate",
    //     params: {
    //       studySetId: studySetId,
    //     },
    //   });
    // },
    async handleConfirmDeleteReadAloud() {
      try {
        await this.deleteReadAloudAction(this.readAloudId);
        successMessage(this.$t("study_sets.delete_study_set_success"))(this);
        return this.$router.push({
          name: "readalouds",
          params: {
            readAloudId: this.readAloudId,
          },
        });
      } catch (error) {
        return warningMessage(this.$t("study_sets.delete_study_set_warning"))(
          this
        );
      }
    },
    handleEditReadAloud() {
      if (this.canAccessReadAloud(this.readAloudId, 'view')) {
        return warningMessage(
          this.$t("read_aloud.messages.edit_disabled_message"),
          'elsa-message info'
        )(this);
      }

      return this.$router.push({
        name: "read-aloud-edit",
        params: {
          readAloudId: this.readAloudId,
        },
      });
    },
    handleAssignStudySetToClass() {
      this.$store.dispatch("readAlouds/resetBuildingStudySet");
      this.modals.showCreateStudySetSuccessModal = false;
      return this.$router.push({
        name: "studysets",
        params: {
          organizationId: this.currentOrganizationId,
        },
      });
    },
    async handleReload() {
      try {
        this.handleCheckReadAloudPermission(Number(this.readAloudId));
        await this.$store.dispatch("readAlouds/getReadAloud", {
          readAloudId: this.readAloudId,
        });
        const readAloud = this.getDetailReadAloud;
        let buildingReadAloudData = {}
        if (!readAloud.warm_up_ss) {
          buildingReadAloudData = {...readAloud};
        } else {
          buildingReadAloudData = {
          ...readAloud,
          warm_up_ss: {
            ...readAloud.warm_up_ss,
            phrases: readAloud.warm_up_ss.phrases.map((x) => {
              return { text: x };
            }),
          },
          };
        }
        this.detailReadAloudData = buildingReadAloudData;
      } catch (error) {
        return warningMessage(this.$t("common.generic_error_message"))(this);
      }
    },
    async handleEditName(newName) {
      const payload = { name: newName };
      this.loading = true;
      this.editMode = false;
      try {
        await this.updateReadAloudName({
          readAloudId: this.readAloudId,
          payload: payload,
        });
        this.detailReadAloudData.name = newName;
        successMessage(this.$t("common.update_name_success"))(this);
      } catch (error) {
        return warningMessage(this.$t("common.generic_error_message"))(this);
      } finally {
        this.loading = false;
      }
    },
    cancelRename() {
      this.editMode = false;
    },
    canAccessReadAloud(readAloudId, action = "edit") {
      return this.checkedReadAlouds[action].includes(Number(readAloudId));
    },
    async handleCheckReadAloudPermission(readAloudId) {
      try {
        this.checkedReadAlouds = await this.checkReadAloudPermission([
          readAloudId,
        ]);
      } catch (error) {
        error;
      }
    },
  },
  async mounted() {
    await this.handleReload();
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/colors.scss";
.read-aloud-detail {
  width: 100%;
}
.back-text {
  color: #007eff;
  font-weight: 600;
}
.study-set-name {
  font-size: 30px;
  line-height: 45px;
  font-weight: 700;
  margin-top: 0px;
  margin-bottom: 0px;
  display: flex;
}

.sub-header {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 16px;
}

#assign-to-group-btn ::v-deep {
  .el-button {
    padding: 8px 16px !important;
  }

  .elsa-chip {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
}

.assign-to-class {
  margin-right: 8px;
}

.remove-read-aloud {
  color: red;
}

#read-aloud-page {
  margin: 8px;
  @media only screen and (max-width: 768px) {
    margin: 0 30px;
  }
  h1 {
    border: 0;
  }
  .read-aloud-main {
    background-color: white;
    padding: 0px;
  }
  ::v-deep .base-create-header {
    padding-bottom: 34px;
  }
  ::v-deep .circle-step {
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-radius: 23px;
    width: 40px;
    height: 40px;
    display: inline-flex;
    justify-content: center;
    padding-top: 8px;
    margin-right: 16px;
  }
}
.edit-name {
  color: #478dff;
  cursor: pointer;
  padding: 0px 13px;
  margin-top: 6px;
}
.actions-list-item {
  width: 24px;
  height: 24px;
  padding-right: 8px;
}
.btn-edit-disabled {
  color: #c0c4cc !important;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;

  svg {
    color: #c0c4cc !important;
  }
}
#leave-modal-title {
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  text-align: center;
  color: $black;
  margin: 0 auto;
}
</style>
